// Placeholder service for UGC AV feedback (to be wired to Lumo backend)
export const ugcFeedbackService = {
  async requestFeedback({ videoId, url, userId }) {
    // TODO: call backend/Lumo for AV analysis once available
    console.log('Requesting feedback for', { videoId, url, userId });
    return {
      summary: 'Pending feedback — this will be handled by Lumo soon.',
      suggestions: [
        'Open strong with a 1s hook and on-screen text.',
        'Add captions and tighten pacing to 12–15s.',
        'Clarify CTA in the last 3 seconds.'
      ]
    };
  }
};
